import * as actionTypes from '../types/auth';

const initialState = {
  token: null,
  loading: false,
  error: false,
  urlWebSSO: {
    login: null,
    logout: null
  }
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.AUTH_REQUEST:
      return {
        ...state,
        error: false,
        loading: true
      };

    case actionTypes.AUTH_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        token: true
      };

    case actionTypes.AUTH_FAIL:
      return {
        ...state,
        error: payload,
        loading: false
      };

    case actionTypes.GET_URL_WEBSSO_LOGIN_SUCCESS:
      return {
        ...state,
        urlWebSSO: {
          ...state.urlWebSSO,
          login: payload
        }
      };

    case actionTypes.GET_URL_WEBSSO_LOGOUT_SUCCESS:
      return {
        ...state,
        urlWebSSO: {
          ...state.urlWebSSO,
          logout: payload
        }
      };

    default:
      return state;
  }
};

export default reducer;
